import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.css'],
})
export class PrivacyPolicyComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<PrivacyPolicyComponent>) {}

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }
}
